import { ReactNode } from 'react'

import { FormProvider, useForm } from 'react-hook-form'

import { TimePeriod } from 'components/reports/Metrics/constants/ExceptionMetrics'
import { VehicleTypeFilter } from 'generated/graphql'

export interface NetworkGrowthFilterValues {
  period: TimePeriod
  customStart: Date | null
  customEnd: Date | null
  vehicleType: VehicleTypeFilter
}

export const NETWORK_GROWTH_DEFAULT_FILTERS: NetworkGrowthFilterValues = {
  period: 'last30',
  customStart: null,
  customEnd: null,
  vehicleType: VehicleTypeFilter.All,
}

interface IProps {
  children: ReactNode
}

export const NetworkGrowthFilterCriteria = ({ children }: IProps) => {
  const methods = useForm<NetworkGrowthFilterValues>({
    defaultValues: NETWORK_GROWTH_DEFAULT_FILTERS,
  })

  return <FormProvider {...methods}>{children}</FormProvider>
}
